import { createApp } from 'vue'
import App  from "./vue/App";
import store from "./store";

function onReady ()
{
    const app = createApp(App);
     app
         .use(store)
         .provide("initialResults", initialResults) //inject in JS from PHP
         .provide("filters", filters) //inject in JS from PHP
         .provide("copydeck", copydeck.search) //inject in JS from PHP
         .provide("type", strType) //inject in JS from PHP
         .mount('#main');

     window.search = app;
}


document.addEventListener('DOMContentLoaded', onReady);


